import { render } from "./MonitoringModal.vue?vue&type=template&id=c24467e6&scoped=true&ts=true"
import script from "./MonitoringModal.vue?vue&type=script&lang=ts"
export * from "./MonitoringModal.vue?vue&type=script&lang=ts"

import "./MonitoringModal.vue?vue&type=style&index=0&id=c24467e6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c24467e6"]])

export default __exports__